/**
 * 消费限额提示
 * @author lianghua.fu
 * @date 2022-03-29 22:28:23
 */
import { UiModal } from 'components';
import { storage, utils, request } from 'lib';

const cacheKey = 'SENT_TIP';
let isContinueSend = false; // 是否继续送

// room/send_gift
// multireceiver/send_gift.json
//
//
// user_consume_day_limit  用户单日消费限额提醒
// user_consume_single_limit 用户单次消费限额提醒
// data里面有个content字段，是弹窗内容
// 这两个接口是用户点击今日不再提示调用一下 我保存一下 带一下用户token就可以
// /api/v1/user/close-consume/day  单日限额弹窗不再提示调用接口
// /api/v1/user/close-consume/single  单次限额弹窗不再提示调用接口

//  35001 单次限额提示
//  35002 单次限额限制
//  35003 单日限额提示
//  35004 单日限额限制
const handleTip = (res, onSend) => {
  getCache();
  // const cache = storage.getItem(cacheKey) || {}
  //
  // const today = utils.formatTime(Date.now(),'yyyyMMdd')
  //
  // const todayCache = cache[today]||{}

  // res.type 与 policy_flag_type 一致
  let userType = ['', '_star'][res.type || 0];
  let cacheType = '';
  switch (res.code) {
    case 35001:
      cacheType = 'single_before' + userType;
      if (!todayCache[cacheType]) {
        UiModal.alert({
          title: '温馨提示',
          content:
            '看直播享娱乐，建议理性消费，本次打赏金额较高，是否继续打赏？',
          okText: '继续打赏',
          cancelText: '取消',
          checkTipEnable: true,
          checkTipDefaultStatus: true,
          checkTipText: '今日不再提示',
          onOk: async ({ isCheckTip }) => {
            if (isCheckTip) {
              todayCache[cacheType] = true;
              saveCache();
              await request.cryolite.get('api/v1/user/close-consume/single');
            }
            isContinueSend = true;
            onSend();
          },
          onCancel: ({ isCheckTip }) => {
            // if (isCheckTip) {
            //   todayCache.single_before = true;
            //   saveCache();
            // }
          },
        });
      }
      return true;
    case 35002:
      UiModal.alert(
        '温馨提示',
        `本次打赏金额较高，已超过单次打赏金额上限，建议调整本次打赏礼物的数量或更换其他礼物`,
        () => {},
        '确定',
      );
      return true;
    case 35003:
      cacheType = 'day_before' + userType;
      if (!todayCache[cacheType]) {
        UiModal.alert({
          title: '温馨提示',
          content:
            '看直播享娱乐，建议理性消费，今日累计打赏金额已较高，是否继续打赏？',
          okText: '继续打赏',
          cancelText: '取消',
          checkTipEnable: true,
          checkTipDefaultStatus: true,
          checkTipText: '今日不再提示',
          onOk: async ({ isCheckTip }) => {
            if (isCheckTip) {
              todayCache[cacheType] = true;
              saveCache();
              await request.cryolite.get('api/v1/user/close-consume/day');
            }
            isContinueSend = true;
            onSend();
          },
          onCancel: ({ isCheckTip }) => {
            // if (isCheckTip) {
            //   todayCache.day_before = true;
            //   saveCache();
            // }
          },
        });
      }
      return true;
    case 35004:
      UiModal.alert({
        title: '温馨提示',
        content: `今日累计打赏已超过单日打赏金额上限，建议理性消费，如需帮助请联系客服`,
        okText: '联系客服',
        onOk: () => {
          MM.user.kefu.showKefu();
        },
      });
      return true;
  }
};

const saveCache = () => {
  const today = utils.formatTime(Date.now(), 'yyyyMMdd');
  storage.setItem(cacheKey, {
    [today]: todayCache,
  });
};

const handleSocket = (socket) => {
  todayCache = getCache();
  // 用户单次消费限额提醒
  socket.on('user_consume_single_limit', (msg) => {
    // type  1:主播 0:用户
    const type = `single${['', '_star'][msg.data.type]}`;
    if (!todayCache[type]) {
      // '看直播享娱乐，建议理性消费，单次打赏金额已较高，请确认为本人消费',
      UiModal.alert({
        title: '温馨提示',
        content: msg.data.content,
        okText: '确认',
        checkTipEnable: true,
        checkTipDefaultStatus: true,
        checkTipText: '今日不再提示',
        onOk: async ({ isCheckTip }) => {
          if (isCheckTip) {
            todayCache[type] = true;
            saveCache();
          }
        },
      });
    }
  });
  // 用户单日消费限额提醒
  socket.on('user_consume_day_limit', (msg) => {
    // type  1:主播 0:用户
    const type = `day${['', '_star'][msg.data.type]}`;

    if (!todayCache[type]) {
      // '看直播享娱乐，建议理性消费，今日累计打赏金额已较高，请确认为本人消费'
      UiModal.alert({
        title: '温馨提示',
        content: msg.data.content,
        okText: '确认',
        checkTipEnable: true,
        checkTipDefaultStatus: true,
        checkTipText: '今日不再提示',
        onOk: async ({ isCheckTip }) => {
          if (isCheckTip) {
            todayCache[type] = true;
            saveCache();
          }
        },
      });
    }
  });
};

let todayCache;

const getCache = () => {
  if (todayCache) {
    return todayCache;
  }
  const cache = storage.getItem(cacheKey) || {};

  const today = utils.formatTime(Date.now(), 'yyyyMMdd');

  todayCache = cache[today] || {};
  return todayCache;
};

// 用户和主播区分标识
// policy_flag值对应的场景
// 3：单次和今日的都没弹
// 2：单次弹过，今日没弹
// 1：单次没弹，今日弹过
// policy_flag_type  提示的标识 区分主播、用户，主播：1，用户：0
const getPolicyFlag = (isStar) => {
  if (isContinueSend) {
    isContinueSend = false;
    return 0;
  }

  const userType = isStar ? '_star' : '';

  todayCache = getCache();
  if (
    !todayCache[`single_before${userType}`] &&
    !todayCache[`day_before${userType}`]
  ) {
    return 3;
  }
  if (!todayCache[`single_before${userType}`]) {
    return 1;
  }
  if (!todayCache[`day_before${userType}`]) {
    return 2;
  }
  return 0;
};

export default {
  handleTip,
  handleSocket,
  getPolicyFlag,
};
